export const STORAGE_KEYS = {
  sidebarCollapsed: 'calypso.sidebar.collapsed',
} as const;
